import React from 'react';
import useOnClickOutside from '@Utils/shared/hooks/useOnClickOutside';
import { useTooltipContext } from './tooltipContext';
import * as Styled from './Tooltip.styled';

interface OwnProps {
  title: string;
  description: string;
  screenShot1: string;
  screenShot2: string;
}

const Tooltip: React.FC<OwnProps> = ({ title, description, screenShot1, screenShot2 }) => {
  const { isShow, setIsShow, setSize, coords } = useTooltipContext();
  const tooltipRef = React.useRef<HTMLDivElement | null>(null);

  const hideTooltip = () => {
    setIsShow(false);
  };

  useOnClickOutside(tooltipRef, hideTooltip);

  React.useEffect(() => {
    const coords = tooltipRef.current?.getBoundingClientRect();
    if (coords) {
      setSize({ height: coords.height, width: coords.width });
    }
  }, [setSize]);

  return (
    <Styled.Tooltip
      ref={tooltipRef}
      isShow={isShow}
      left={coords.x || 0}
      style={{ top: coords.y || 0 }}
    >
      <Styled.TooltipScrollContainer>
        <Styled.TooltipTitle>{title}</Styled.TooltipTitle>
        <Styled.TooltipText>{description}</Styled.TooltipText>
        <Styled.TooltipScreenshotsWrapper>
          <img src={screenShot1} />
          <img src={screenShot2} />
        </Styled.TooltipScreenshotsWrapper>
      </Styled.TooltipScrollContainer>
    </Styled.Tooltip>
  );
};

export default Tooltip;
